import React from 'react';

import { useTranslation } from 'react-i18next';

import { BreadCrumbs } from 'components/lds';

type Props = {
  listPageUrl: string;
};

export function Breadcrumbs({ listPageUrl }: Props) {
  const { t } = useTranslation();

  return (
    <BreadCrumbs
      links={[
        {
          label: t('web.admin.inspections.templateCustomize.breadcrumbList'),
          url: listPageUrl,
        },
        {
          label: t('web.admin.inspections.templateCustomize.breadcrumbEdit'),
        },
      ]}
    />
  );
}
